<template>
  <div id="order-status-modal" class="modal"  v-show="modalShown">
    <div class="modal-main">
      <div class="title-area">
        <h2>受注ステータス設定</h2>
      </div>
      <!-- ローディングモーダル -->
      <dd-loading-modal ref="loadingModalRef" />
      <div class="data-area">
        <ul>
          <li>
            <span class="label">受注ステータス</span>
            <select v-model="orderStatus" class="form_contents">
              <option v-for="(status, index) in orderStatusData" :key= index :value="status.code" >{{status.label}}</option>
            </select>
          </li>
        </ul>
      </div>
      <div class="button-area">
      <button type="button" class="main_btn" @click="updateOrderStatus">設定</button>
      <button type="button" class="main_btn" @click="onCancel">キャンセル</button>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../../utils/Api'
import * as AppUtil from '../../../utils/App'
import {API_URL} from '../../../constants/App'
import LoadingModal from '../../common/LoadingModal'

export default {
  name: 'PlanOdrerStatusModal',
  components: {
    'dd-loading-modal': LoadingModal
  },
  props: {
    orderStatusData: Array
  },
  data () {
    return {
      /** モーダル開閉 */
      modalShown: false,
      /** 受注ステータス */
      orderStatus: 0,
      /** 編集中データ */
      editData: null
    }
  },
  methods: {
    /** 新規モーダル */
    showModal: function (data) {
      this.editData = data
      this.orderStatus = data.cpropertyOrderStatus
      this.modalShown = true
    },
    /** キャンセル */
    onCancel: function () {
      this.modalShown = false
    },
    /** 受注ステータス更新 */
    updateOrderStatus: function () {
      this.$refs.loadingModalRef.showModal(true)
      let payload = {
        propertyId: this.editData.cpropertyId,
        orderStatus: this.orderStatus
      }
      axios.post(API_URL.PROPERTY + '/status/update', payload
      ).then(response => {
        this.$refs.loadingModalRef.showModal(false)
        let modalData = {
          messages: ['変更しました'],
          onOk: () => {
            this.modalShown = false
            this.$emit('getPropertyList')
          }
        }
        this.validateErrorMessages = {}
        AppUtil.showModal(modalData)
      }).catch(error => {
        this.$refs.loadingModalRef.showModal(false)
        this.validateErrorMessages = {}
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
li{
  margin-bottom: 20px;
  div{
    width: 175px;
    display: inline-block;
    padding: 10px;
    text-align: left;
  }
  .label{
    min-width: 190px;
    display: inline-block;
    text-align: left;
    font-weight: bold;
  }
}
.data-area {
  padding: 20px;
  max-height: 620px;
  overflow: auto;
}
.modal-main{
  max-height: 100%;
}
.count_limit{
  font-size: 8px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/components/list/modal/OrderStatusModal.vue